module.exports = __webpack_public_path__ + "static/media/cover.eb83cb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover.png
// module id = 141
// module chunks = 0